import { ConfigData } from "@/core";
import { repositoryHost } from "@/repositories";
import { serviceHost } from "@/services";
import { useUserStore } from "@/stores/user";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const databaseService = serviceHost.getDatabaseService();

const configRepository = repositoryHost.getConfigRepository(databaseService);

const CONFIG_ID = "config";

export const useConfig = () => {
  return useQuery({
    queryKey: ["config", CONFIG_ID],
    queryFn: async () => {
      const config = await configRepository.get({ id: CONFIG_ID });
      if (!config) {
        // Return default config structure if it doesn't exist
        return null;
      }
      return config;
    },
  });
};

export const useSetConfig = () => {
  const queryClient = useQueryClient();
  const { hasFullAccess } = useUserStore();

  return useMutation<void, Error, ConfigData>({
    mutationKey: ["config", "set"],
    mutationFn: async (params: ConfigData) => {
      if (!hasFullAccess()) {
        throw new Error(
          "Access denied: Full access required to update config",
        );
      }
      return configRepository.set({ id: CONFIG_ID, data: params });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["config", CONFIG_ID] });
    },
  });
};
